<div class="chat-width-a">
    <h2 mat-dialog-title class="md-title chat-cont-a">
        <img src='../../assets/images/logoclaro2.png' style='width:32px;height:32px; vertical-align: middle;'>
        <label class='labTitle chatTitle-b'>¿ Necesitas Ayuda ?</label>
        <div (click)="this.close()" class="closeChat">
            X
        </div>
    </h2>
    <mat-dialog-content class="chat-cont-a">
    <div class="chatJAC" >
            <div class="containerA" id="idChatPreg" title="Chat Claro">
                <div class='grid-item item2'>
                    <b>Bienvenido a nuestro Chat en Línea</b>
                </div>
                <div class='grid-item item3 ajustificado'>
                    Debido al alto volumen de interacciones a través del  Chat, nuestros operadores están ocupados atendiendo a otros clientes. Solicitamos su indulgencia y paciencia. Lamentamos los inconvenientes que esto pueda causar.  Para tener acceso inmediato a la información de tu cuenta entra a <a href="https://miclaro.claropr.com\" target="_blank\">https://miclaro.claropr.com</a> clientes de negocio <a href="https://empresas.claropr.com\" target="_blank\">https://empresas.claropr.com</a>.<br><br>
                    <div id='errorChat' class='errorChat'></div>
                </div>
                <div class='grid-item item4' *ngIf="!this.isLogged">
                    <input type='text' id='idNombreChat' placeholder='Nombre y Apellido' class='chatInput'[(ngModel)]="this.name" >
                    <!-- <input type='text' id='idNombreChat' placeholder='Nombre y Apellido' class='inputChat' > -->
                </div>
                <div class='grid-item item4' *ngIf="this.isLogged">
                    <input type='text' id='idNombreChat' placeholder='Nombre y Apellido' class='chatInput'[(ngModel)]="this.name" readonly>
                    <!-- <input type='text' id='idNombreChat' placeholder='Nombre y Apellido' class='inputChat' > -->
                </div>
                <div class='grid-item item5' *ngIf="!this.isLogged">
                    <input type='text' id='idEmailChat' placeholder='Correo' class='chatInput' [(ngModel)]="email">
                </div>
                <div class='grid-item item5' *ngIf="this.isLogged">
                    <input type='text' id='idEmailChat' placeholder='Correo' class='chatInput' [(ngModel)]="email" readonly>
                </div>
                <div class='grid-item item9'>
                    Pregunta
                </div>
                <div class='grid-item item10'>
                    <textarea class='textAreaChat' id='idPreguntaChat' [(ngModel)]="this.message"></textarea>
                </div>
                <div class='grid-item item11'>
                    <div class="styleAdvice">
                        En estos momentos Claro PR no estará suspendiendo por falta de pago o limitando los datos de nuestros clientes, para más información ingresa a <a target="_blank" href="http://bit.ly/2UhXYh4">http://bit.ly/2UhXYh4</a>
                    </div>
                    <button id='idEnviarChat' title='Continuar' class='botonEncuesta' (click)='irChat();'>
                        Continuar
                        <i style='margin-left: 7px;' class='fa fa-chevron-right'></i>
                    </button>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>